import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../services/data.service';
import { LocaleService } from '../../../services/locale.service';

@Component({
  selector: 'app-contribuente-pratica-dettaglio',
  templateUrl: './contribuente-pratica-dettaglio.component.html',
  styleUrls: ['./contribuente-pratica-dettaglio.component.css']
})
export class ContribuentePraticaDettaglioComponent implements OnInit {
	@Input() selectedRow: string = '';
	@Input() writePermission: boolean;
	@Input() readOnly: boolean = true;
	@Input() parametriString: string = '';
	@Output() updateEvents = new EventEmitter();

	parametri: any = {};
	localPermission: boolean = false;
	tributi: any[] = [];
	tributiSync: Subscription;

	fasi: any[] = [];
	fasiSync: Subscription;

	dettagliPratica: any[] = [];
	num_dettagli = 0;
	dettagliPraticaSync: Subscription;

	infoPratica: any = [];
	notifica_spese_agg: any = 0;
	oneri_risc: any = 0;
	spese_esecutive: any = 0;
	totale_da_pagare: any = 0;

	constructor(
		private dataService: DataService,
		private formatter: LocaleService
		) {}

	ngOnInit() {
		this.tributiSync = this.dataService.tipiTributo$.subscribe(
			tipiTributo => {
				this.tributi = tipiTributo;
			});
		this.fasiSync = this.dataService.tipiFase$.subscribe(
			tipiFase => {
				this.fasi = tipiFase;
			});
		let data: any = JSON.parse(this.selectedRow);
		//console.debug('CONTRIB-PRATICADETTAGLIO| INIT', data);
		this.infoPratica = data.infoPratica;
		this.dettagliPratica = data.dettagliPratica;
		this.totale_da_pagare = this.infoPratica.totale_dovuto;
		this.localPermission = this.writePermission && !this.readOnly;
		this.loadData();
	}

	ngOnChanges(changes: any){
		console.debug('CONTRIB-PRATICADETTAGLIO| CHANGES', changes);
		if (changes.selectedRow) {
			let data: any = JSON.parse(this.selectedRow);
			//console.debug('CONTRIB-PRATICADETTAGLIO| CHANGED DATA', data);
			this.infoPratica = data.infoPratica;
			this.dettagliPratica = data.dettagliPratica;
			console.debug('CONTRIB-PRATICADETTAGLIO| DATA', this.infoPratica, this.dettagliPratica);
			this.parametri = JSON.parse(this.parametriString);
			console.debug('CONTRIB-PRATICADETTAGLIO| CHANGED PARAM 1', this.parametri);
			this.loadData();
		}
		if (changes.parametriString) {
			this.parametri = JSON.parse(this.parametriString);
			console.debug('CONTRIB-PRATICADETTAGLIO| CHANGED PARAM 2', this.parametri);
		}
	}

	loadData(){
		this.notifica_spese_agg = 0.00;
		this.spese_esecutive = 0.00;
		this.oneri_risc = 0.00;
		this.num_dettagli = 0;
		this.totale_da_pagare = 0.00;
		this.fillSummedAttributePraticaDettagli();
		this.fillSummedAttributePratica();
		this.updateEvents.emit(this.dettagliPratica);
	}

	formatValori(){
		let numberKeys = ['dovuto', 'arrotondamento', 'versato',
		'sanzioni', 'interessi', 'notifica_spese',
		'oneri_risc_attuali', 'oneri_risc_entro_30', 'oneri_risc_dopo_30',
		'interessi_agg', 'interessi_agg_prec'];

		for(let row of this.dettagliPratica){
			//console.debug('CONTRIB-PRATICADETTAGLIO| PRATDETTAGLI', row);
			for(let key of numberKeys){
				row[key] = this.formatter.nz(row[key]);
				row[key] = this.formatter.twoDigitsDecimal(row[key]).toString();
			}
		}
	}

	aggiornaValori(){
		this.loadData();
	}

	fillSummedAttributePraticaDettagli(){
		this.totale_da_pagare = 0.00;
		for(let row of this.dettagliPratica){
			//console.debug('CONTRIB-PRATICADETTAGLIO| SUMMEDPRATDETTAGLI', row);
			this.oneri_risc += Number(row.oneri_risc_attuali);
			this.totale_da_pagare += Number(row.dovuto) - Number(row.versato) + Number(row.sanzioni) + Number(row.interessi) + Number(row.notifica_spese) + Number(row.oneri_risc_attuali) + Number(row.sanzioni_agg_prec) + Number(row.sanzioni_agg) + Number(row.interessi_agg_prec) + Number(row.interessi_agg) + Number(row.arrotondamento);
			this.num_dettagli++;
		}
	}

	fillSummedAttributePratica(){
		this.spese_esecutive = Number(this.infoPratica.diritti_pf_agg) + Number(this.infoPratica.diritti_pf_agg_prec);
		this.notifica_spese_agg += Number(this.infoPratica.notifica_spese_agg) + Number(this.infoPratica.notifica_spese_agg_prec);
		this.totale_da_pagare += this.spese_esecutive + this.notifica_spese_agg;
	}

	reset(){
		this.parametri.ricalcolaRettifica = false;
	}

	ngOnDestroy() {
		this.tributiSync.unsubscribe();
		this.fasiSync.unsubscribe();
	}
}
